<template>
  <DxPopup
    :visible="visible"
    :title="t('guidance.stopConfirmTitle')"
    :width="420"
    :height="'auto'"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :shading="false"
    :wrapper-attr="{ class: 'guidance-stop-modal-wrapper' }"
    @update:visible="emit('update:visible', $event)"
  >
    <div class="guidance-stop-modal__text">
      {{ t("guidance.stopConfirmMessage") }}
    </div>
    <div class="guidance-stop-modal__actions">
      <DxButton
        :text="t('guidance.stopConfirmCancel')"
        type="normal"
        styling-mode="outlined"
        @click="emit('update:visible', false)"
      />
      <DxButton
        :text="t('guidance.stopConfirmOk')"
        type="danger"
        styling-mode="contained"
        @click="handleConfirm"
      />
    </div>
  </DxPopup>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { DxPopup } from "devextreme-vue";
import DxButton from "devextreme-vue/button";

interface Props {
  visible: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  "update:visible": [value: boolean];
  confirm: [];
}>();

const { t } = useI18n();

function handleConfirm() {
  emit("update:visible", false);
  emit("confirm");
}
</script>
